import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, signal, inject } from "@angular/core";
import { ActivityIndicatorService, IActivityPrompt } from "../../services/activity-indicator.service";
import { fadeOut, zoomInOut } from "../../core-ui.animations";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-activity-indicator",
  templateUrl: "./activity-indicator.component.html",
  styleUrls: ["./activity-indicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [zoomInOut, fadeOut],
  standalone: false,
})
export class ActivityIndicatorComponent implements OnInit {
  private activity = inject(ActivityIndicatorService);
  private host = inject(ElementRef);
  private renderer = inject(Renderer2);
  private translate = inject(TranslateService);

  visible = signal<boolean>(false);
  message = signal<string>(undefined);
  icon = signal<string>(undefined);
  cssClass = signal<string>(undefined);
  backdropVisible = signal<boolean>(false);
  prompt = signal<IActivityPrompt>(undefined);

  ngOnInit() {
    this.activity.message$.subscribe((val) => {
      this.message.set(val);
      if (this.message())
        this.renderer.setAttribute(
          this.host.nativeElement,
          "aria-label",
          this.translate.instant(this.message())
        );
    });
    this.activity.isVisible$.subscribe((val) => {
      this.visible.set(val);
      if (this.visible()) {
        this.renderer.setAttribute(this.host.nativeElement, "role", "alert");
      } else {
        this.renderer.removeAttribute(this.host.nativeElement, "role");
        this.renderer.removeAttribute(this.host.nativeElement, "aria-label");
      }
    });
    this.activity.icon$.subscribe((val) => {
      this.icon.set(val.name);
      this.cssClass.set(val.cssClass);
    });
    this.activity.backdrop$.subscribe((val) => this.backdropVisible.set(val));
    this.activity.prompt$.subscribe((val) => this.prompt.set(val));
  }

  retry() {
    this.activity.retryPrompt();
  }
}
